export default "__VITE_ASSET__KvJwHB$l__"